import { Injectable, OnDestroy, Renderer2, RendererFactory2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DropdownService implements OnDestroy {
  private routerSubscription: Subscription | null = null;
  private renderer: Renderer2;

  constructor(private readonly router: Router, private readonly rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.subscribeToRouterEvents();
  }

  // Subscribe to router events and trigger the dropdown close on navigation
  private subscribeToRouterEvents(): void {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closeAllDropdowns();
      }
    });
  }

  // Close all dropdowns in st tables by removing 'ant-select-open' class globally
  private closeAllDropdowns(): void {
    const dropdownElements = document.querySelectorAll('.ant-select-dropdown');
    dropdownElements.forEach((dropdown) => {
      this.renderer.setStyle(dropdown, 'display', 'none');
    });
  }

  // Clean up the router subscription when no longer needed
  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
